import * as React from "preact";
import { Fragment, FunctionComponent } from "preact";
import { useEffect, useState } from "preact/hooks";
import FormInput from "./components/StringInput";
import FormLabel from "./components/FormLabel";
import Validation from "../components/Validation";
import Loading from "../components/Loading";

interface IAppProps {
  fileUploadLimit: number;
  apiKey: string;
  apiSubmitUrl: string;
  apiImageUploadUrl: string;
  stringParameters: any;
  imageParameters: any;
  documentKey: string;
}

const App: FunctionComponent<IAppProps> = ({
  fileUploadLimit,
  apiKey,
  apiSubmitUrl,
  apiImageUploadUrl,
  stringParameters,
  imageParameters,
  documentKey,
}) => {
  const [imgParams, setImgParams] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState("");
  const stringParams = JSON.parse(stringParameters);
  const imageParams = JSON.parse(imageParameters);

  useEffect(() => {}, [validationError]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validationError) {
      let formData = new FormData(e.target);

      let sParams = stringParams.map((item) => ({
        key: item.key,
        value: formData.get(item.key),
      }));
      exportPdf(sParams);
    }
  };

  const renderLoading = () => {
    return loading ? <Loading text=" " /> : null;
  };

  const checkFileSize = (file: File) => {
    let fileSize = file.size / 1024 / 1024;
    if (fileSize > fileUploadLimit) {
      return false;
    }
    return true;
  };

  const exportPdf = (stringParamsArray: []) => {
    setLoading(true);
    let req = {
      documentKey: documentKey,
      stringParameters: stringParamsArray,
      imageProperties: imgParams,
    };
    return fetch(`${apiSubmitUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": `${apiKey}`,
      },
      body: JSON.stringify(req),
    })
      .then((res) => res.blob())
      .then((blob) => {
        setLoading(false);
        downloadFile(blob, documentKey + ".pdf");
      });
  };

  function downloadFile(blob, name = "file.pdf") {
    const href = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), {
      href,
      style: "display:none",
      download: name,
    });
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(href);
    a.remove();
  }

  const handleChange = (e) => {
    if (e.target.files[0]) {
      setLoading(true);
      const file: File = e.target.files[0];
      const pattern = /image-*/;

      if (file.type.match(pattern)) {
        let isImageUnderFive = checkFileSize(file);
        if (isImageUnderFive) {
          postFile(file, e.target.name);
          setValidationError("");
        } else {
          setValidationError(`File upload is too large, please upload images under ${fileUploadLimit}mb`);
          e.target.value = "";
        }
      } else {
        let validationMessage = "Please upload jpeg or png files";
        setValidationError(validationMessage);
        e.target.value = "";
      }
      setLoading(false);
    }
  };

  const postFile = (file: any, inputId: string) => {
    let imgIndex = imgParams.findIndex((x) => {
      if (x.imageId === inputId) {
        return true;
      }
      return false;
    });
    if (imgIndex > -1) {
      imgParams[imgIndex].fileName = file.name;
    } else {
      imgParams.push({ fileName: file.name, imageId: inputId });
    }
    setImgParams(imgParams);
    const formData = new FormData();
    formData.append("file", file, file.name);
    return fetch(`${apiImageUploadUrl}`, {
      method: "POST",
      headers: {
        "x-api-key": `${apiKey}`,
      },
      body: formData,
    }).then(() => {
      setLoading(false);
    });
  };

  return (
    <div className="container">
      <div className="container__inner">
        <div className="base-form__container">
          <form
            className="base-form"
            onSubmit={handleSubmit}
          >
            <div className="base-form__field">
              {stringParams &&
                stringParams.map((item) => (
                  <Fragment>
                    <FormLabel
                      key={item.key}
                      value={item.value}
                    ></FormLabel>
                    <FormInput
                      keyId={item.key}
                      isFile={false}
                      handleChange={undefined}
                    ></FormInput>
                  </Fragment>
                ))}
            </div>
            <div className="base-form__field">
              {imageParams &&
                imageParams.map((imageItem) => (
                  <Fragment>
                    <FormLabel
                      key={imageItem.imageId}
                      value={imageItem.imageName}
                    ></FormLabel>
                    <FormInput
                      keyId={imageItem.imageId}
                      isFile={true}
                      handleChange={handleChange}
                    ></FormInput>
                  </Fragment>
                ))}
            </div>

            {validationError && (
              <section className="base-form__errors alert-block alert-block--error">
                <div className="container">
                  <div className="container__inner">
                    <div className="alert-block__inner">
                      <h2 className="alert-block__title">
                        There has been an issue
                      </h2>
                      <div className="alert-block__description">
                        <Validation errorMessage={validationError}></Validation>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            <div className="base-form__controls">
              <button
                disabled={loading}
                type="submit"
                className="cta cta--highlight"
              >
                Download
              </button>
              {renderLoading()}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default App;
